import {Alarm, UserAuthStatus} from '@web/core/constants'
import {getApplyFailure} from '@web/slices/orderProcessor/slice'
import makeSlice from '@web/slices/purchaser/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const purchaserSlice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {purchaser, naverMembership, userAuthStatus} = payload

                state.naverIdNo = purchaser.nidno

                /** 알림 수신 수단이 SMS인 경우, 수신 수단 업데이트 필요 */
                state.shouldUpdateAlarmType = purchaser.alarmType === Alarm.SMS
                state.alarmType = purchaser.alarmType

                state.adult = purchaser.adult
                state.child = purchaser.child
                state.emailAddress = purchaser.emailAddress
                state.name = purchaser.name ?? ''
                state.phoneNumber = purchaser.phoneNumber
                state.duplicatePhoneNumberUsingMember = purchaser.duplicatePhoneNumberUsingMember
                state.userAuthStatus = userAuthStatus ?? UserAuthStatus.CERTIFICATE

                state.naverMembership = {
                    ...naverMembership,
                    shouldShowQuickJoinMembershipBanner: naverMembership.quickJoinMembershipBannerExposure,
                }
            })
            .addCase(getApplyFailure.fulfilled, (state, {payload}) => {
                state.userAuthStatus = payload.userAuthStatus ?? UserAuthStatus.CERTIFICATE
            })
    },
})

export default purchaserSlice.reducer
export const actions = purchaserSlice.actions
